import {closeActiveMenus} from './menu.js';

const notification_id = "site-action-sheet";

export function addActionSheet({type, message, heading = null}, dismiss_delay = 5000) {
    const is_success = type === 'success',
        btn_close = '<i class="close-sheet fa fa-xmark position-absolute"></i>';

    let menu_class = 'bg-green-dark',
        icon_class = 'fa-check-circle',
        str_heading = '';

    if (!is_success) {
        menu_class = 'bg-red-dark';
        icon_class = 'fa-times-circle';
    }

    if (heading !== null) {
        str_heading = `<h1 class="text-center mt-3 text-uppercase color-white font-700">${heading}</h1>`;
    }

    // nl2br
    message = message.replace(/\n/g, "<br />");

    // remove existing notification sheet
    $(`#${notification_id} .menu-active`).remove();

    // hide active menu (so they don't overlap with action-sheet)
    closeActiveMenus();

    const html = `
            <div id="${notification_id}" class="menu menu-box-bottom ${menu_class} menu-active notification-sheet"
                data-menu-destroy="y"
                 data-menu-effect="menu-push">
                ${btn_close}
                <h1 class="text-center mt-4">
                    <i class="fa fa-3x ${icon_class} scale-box color-white shadow-xl rounded-circle notification-icon"></i>
                </h1>
                ${str_heading}
                <div class="color-white mb-4 text-center mx-auto " style="max-width: 500px; width: 85%">
                    ${message}
                </div>
            </div>`;
    // add new notification_sheet to DOM
    $("#page").append(html);

    if (dismiss_delay) {
        setTimeout(function () {
            removeActionSheet();
        }, dismiss_delay);
    }

    $(`.close-sheet,.notification-icon`, $(`#${notification_id}`)).off("click").on("click", function () {
        removeActionSheet();
    });
}

export function removeActionSheet() {
    $(`#${notification_id}`).remove();
}
